import React, { useContext } from 'react';
import { ConfigContext } from 'contexts/ConfigContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { duotone, light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { getStyledName } from 'utils/modelName';
import FavouritesIcon from 'components/Favourites/FavouritesIcon';
import { usePackage } from 'contexts/PackageContext';
import { Tooltip } from 'antd';
import ModelFeaturesList from 'components/Model/ModelFeaturesList';
import ModelAdditionalInfo from 'components/Model/ModelAdditionalInfo';
import useModelFeatures from 'hooks/useModelFeatures';



const PackageIndexItem = ({
    inShortlist,
    isCurrent,
    model,
    onModelClick,
    activePlaylist,
    onPlaylistClick,
    readOnly
}) => {

    const { packageCode } = usePackage();

    const { clientConfig } = useContext(ConfigContext);
    const { compcardTemplates, exportOptions } = clientConfig

    const playlist = model.Playlists[0];
    const { modelFeatures } = useModelFeatures(model);

    //opzioni di clientConfig.packageIndex: showFeatures e showAdditionalInfo false di default, showModelPlaylists true di default.
    //features e info aggiuntive solo nell'indice: nel drawer di invio shortlist (readOnly) non ci sono
    const packageIndexConfig = clientConfig.packageIndex || {};
    const showFeatures = !readOnly && packageIndexConfig.showFeatures === true
    const showAdditionalInfo = !readOnly && packageIndexConfig.showAdditionalInfo === true

    let modelNameStyle = null;
    if (clientConfig.grid && clientConfig.grid.nameStyle) {
        modelNameStyle = clientConfig.grid.nameStyle;
    }

    const handleClick = model => () => {
        onModelClick(model);
    };

    const hasACompCardBook = () => {
        if (!compcardTemplates || !compcardTemplates.length) {
            return false;
        }
        if (model.Playlists && model.Playlists.length > 0) {
            return model.Playlists.some(playlist => playlist.CompCard);
        }
        return false
    }

    const downloadCompCard = () => {
        const template = compcardTemplates[0]
        let url = '/api/packages/printplaylist?';
        url += 'PackagePlaylistID=' + model.Playlists.find(playlist => playlist.CompCard).ID;
        url += '&PackageCode=' + packageCode;
        url += '&Template=' + template.file;
        url += '&IsCustom=' + (template.isCustom ? 'true' : 'false');
        url += '&Orientation=' + template.orientation;
        window.open(url, '_blank');
    }

    //la modella corrente si espande: intestazione (nome + azioni) e sotto le sue playlist (se packageIndex.showModelPlaylists non e' false)
    const showPlaylists = Boolean(
        packageIndexConfig.showModelPlaylists !== false && isCurrent && !readOnly && model.Playlists.length > 0
    );

    const favouritesIcon = (
        <div className="favourites-icon-container">
            <FavouritesIcon
                modelIDs={{ modelID: model.ModelID, packageModelID: model.ID }}
                inShortlistSection
                tooltipPlacement='left'
            />
        </div>
    );

    const compCardIcon = hasACompCardBook() && exportOptions.pdfCompcard && (
        <div className="download-icon-container">
            <div className="model-download-compcard" onClick={downloadCompCard}>
                <Tooltip
                    placement="left"
                    title="download compcard"
                >
                    <span className="fa-layers fa-fw">
                        <FontAwesomeIcon icon={light('image-polaroid-user')} />
                        <FontAwesomeIcon
                            className="arrow-down"
                            icon={duotone('circle-arrow-down')}
                            transform="shrink-8 down-5 right-6"
                        />
                    </span>
                </Tooltip>
            </div>
        </div>
    );

    const modelName = (
        <div className="model-name" onClick={readOnly || showPlaylists ? null : handleClick(model)}>
            <h3>
                {getStyledName(model, modelNameStyle)}
            </h3>
            {/* {model.note &&
            <div className="model-note-icon">
                <Popover content={<Note>{model.note}</Note>}>
                    <FontAwesomeIcon icon={thin('comment-alt-lines')} />
                </Popover>
            </div>
            } */}
            {inShortlist &&
                <div className="model-in-group-name"><em>{model.Group}</em></div>
            }
        </div>
    );

    //come per il nome: nella modella espansa non si naviga, e' gia' quella aperta
    const infoClick = readOnly || showPlaylists ? null : handleClick(model);

    const additionalInfo = showAdditionalInfo && (
        <ModelAdditionalInfo
            model={model}
            clientConfig={clientConfig}
            onClick={infoClick}
        />
    );

    const features = showFeatures && modelFeatures.length > 0 && (
        <div onClick={infoClick}>
            <ModelFeaturesList
                modelFeatures={modelFeatures}
                nameTag="span"
                valueTag="em"
            />
        </div>
    );

    if (showPlaylists) {
        return (
            <div className="model-cover model-cover-active model-cover-expanded">
                <div className="model-expanded-header">
                    <div className="model-name-and-features">
                        {modelName}
                        {additionalInfo}
                        {features}
                    </div>
                    <div className="model-expanded-actions">
                        {favouritesIcon}
                        {compCardIcon}
                    </div>
                </div>
                <div className="model-playlists">
                    {model.Playlists.map((modelPlaylist, index) => (
                        <div
                            className={`model-playlist ${index === activePlaylist ? 'model-playlist-active' : ''}`}
                            key={`playlist-${modelPlaylist.ID}`}
                            onClick={onPlaylistClick ? () => onPlaylistClick(index) : null}
                        >
                            <div
                                className="model-playlist-cover"
                                style={modelPlaylist.CoverUrl ? { backgroundImage: `url(${modelPlaylist.CoverUrl})` } : undefined}
                            ></div>
                            <div className="model-playlist-name">{modelPlaylist.Name}</div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    return (

        // {model.Playlists.length > 0 &&
        // <Books>{`${model.Playlists.length} book${model.Playlists.length > 1 ? 's' : ''}`}</Books>
        // }

        <div className={`model-cover ${isCurrent ? 'model-cover-active' : ''}`}>
            <div className='model-cover-img' onClick={readOnly ? null : handleClick(model)}>
                <div
                    className='model-cover-backgroundimg-container'
                    style={playlist && playlist.CoverUrl ? { backgroundImage: `url(${playlist.CoverUrl})` } : undefined}
                ></div>
            </div>
            {!readOnly &&
                <>
                    {favouritesIcon}
                    {compCardIcon}
                </>
            }
            <div className="model-name-and-features">
                {modelName}
                {additionalInfo}
                {features}
            </div>
        </div>
    )
}

export default PackageIndexItem

